export default __webpack_public_path__ + "static/media/E1.6fde6ec1.mp3";